<template>
  <el-dialog
    title="上传提货函"
    :visible="visible"
    append-to-body
    modal-append-to-body
    v-bind="$attrs"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align: center;">
      <div class="upload-box">
        <el-upload
          v-loading="isLoading"
          :element-loading-text="loadingText"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          action=""
          list-type="picture-card"
          :show-file-list="false"
          :on-change="handleChange"
          :auto-upload="false"
          @mouseenter.native="isHover = true"
          @mouseleave.native="isHover = false"
        >
          <div
            v-if="fileKeyClone"
            class="avatar"
            :style="{ backgroundImage: `url(${imgUrl})` }"
            style="width: 100%; height: 100%;"
          ></div>
          <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          <el-button v-if="fileKeyClone && isHover" class="avatar-uploader-icon">编辑</el-button>
        </el-upload>
      </div>
      <div class="tip">
        请上传&lt;1M的图片（支持jpg、png等格式）
      </div>
    </div>
    <el-row slot="footer" class="dialog-footer">
      <el-col :span="6" class="text-left">
        <el-link v-show="fileKey" class="m-t10" type="danger" @click="deleteContract"
          >删除提货函</el-link
        >
      </el-col>
      <el-col :span="18">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveContract">保 存</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { uploadFile } from '@/common/services/upload'
import { makeImage } from '@/common/filters'
export default {
  data() {
    return {
      fileKeyClone: '',
      isLoading: false,
      progress: 0,
      isHover: false
    }
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    fileKey: {
      type: String,
      default: ''
    },
    contractId: {
      type: Number,
      default: 0
    },
    // 合同号
    contractNo: {
      type: String,
      default: ''
    },
    // 版本号
    contractVersion: {
      type: Number,
      default: 0
    },
    // 提单号
    dispatchOrderNo: {
      type: String,
      default: ''
    },
    isShowProgress: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: 1 * 1024 * 1024 // 1M
    },
    extraParam: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.fileKeyClone = this.fileKey
        }
      },
      immediate: true
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    onProgress(file) {
      this.progress = parseInt((file.loaded / file.total) * 100)
    },
    // 文件变化的时候，上传
    handleChange(file) {
      let { success, msg } = this.validate(file)
      if (!success) {
        return this.$message.error(msg)
      }
      let fileName = file.name
      file.name = `THH${this.dispatchOrderNo}.${fileName.split('.').slice(-1)[0]}`
      if (file) {
        this.isLoading = true
        // 如果需要上传比例才赋值
        let { onProgress } = this
        onProgress = this.isShowProgress ? onProgress : () => {}
        uploadFile(file, {
          onProgress,
          isPrivate: true,
          extraParam: this.extraParam
        })
          .then(path => {
            // 上传成功
            this.fileKeyClone = path
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    // 限制上传条件
    validate(file) {
      let success = false
      const { maxSize } = this
      const imageTypes = [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'image/pjpeg',
        'image/gif',
        'image/bmp',
        'image/x-png'
      ]
      const isImage = imageTypes.includes(file.raw.type)
      const isLtMaxSize = file.size <= maxSize

      if (!isImage) {
        return {
          success,
          msg: '上传头像图片只能是图片格式!'
        }
      }
      if (!isLtMaxSize) {
        return {
          success,
          msg: `请选择小于${this.maxSizeStr}的图片!`
        }
      }
      return {
        success: true
      }
    },
    // 删除提货函
    async deleteContract() {
      const { success, data } = await this.$post('contract.delete', {
        request: this.contractId
      })
      if (success && data[0].success) {
        this.$message.success('删除提货函成功')
        this.closeDialog()
        this.$emit('reload')
      } else {
        this.$message.error('删除提货函失败')
      }
    },
    async saveContract() {
      if (this.isLoading) {
        return this.$message.error('文件上传中，请稍后')
      }
      const params = {
        fileKey: this.fileKeyClone,
        contractNo: this.contractNo,
        contractVersion: this.contractVersion,
        dispatchOrderNo: this.dispatchOrderNo
      }
      const { success, data } = await this.$post('contract.uploading', {
        request: params
      })
      if (success && data[0].success) {
        this.$message.success('保存成功')
        this.closeDialog()
        this.$emit('reload')
      } else {
        this.$message.error('保存失败')
      }
    }
  },
  computed: {
    imgUrl() {
      return makeImage(this.fileKeyClone, {}, false)
    },
    loadingText() {
      if (this.isShowProgress) {
        if (this.progress < 100) {
          return this.progress + '%'
        } else {
          return '处理中'
        }
      } else {
        return '加载中'
      }
    },
    maxSizeStr() {
      const arr = ['B', 'KB', 'MB', 'GB']
      let ext = arr[0]
      let size = this.maxSize
      for (let i = 0; i < arr.length - 1; i++) {
        if (size / 1024 >= 1) {
          ext = arr[i + 1]
          size = parseInt(size / 1024)
        } else {
          break
        }
      }
      return size + ext
    }
  }
}
</script>

<style scoped>
.upload-box {
  display: inline-block;
  position: relative;
}
.avatar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: 1;
}
.avatar-uploader-icon {
  position: relative;
  z-index: 2;
}
.tip {
  margin-top: 20px;
  color: #999;
}
</style>
